'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './guest.routes';

export class PiperGuestListComponent {

  constructor(Auth, PiperGuestService, dialogs, $uibModal) {
    'ngInject';

    this.PiperGuestService = PiperGuestService;
    this.dialogs = dialogs;
    this.Auth = Auth;
    this.$uibModal = $uibModal;

    this.guests = [];

    PiperGuestService.getByHost({
      hostId: Auth.getCurrentUserSync()._id
    }, (data) => {
      this.guests = data;
    });

  }

  delete(guest) {
    var that = this;

    var guestText = (guest.isBusiness) ? guest.business : guest.firstName + ' ' + guest.lastName;

    var dlg = this.dialogs.confirm("Delete Guest?", "Do you really want to delete your guest?" +
      "<br/><br/><b>" + guestText + "</b>");
    dlg.result.then(() => {
      that.PiperGuestService.delete({id: guest._id},
        () => {
          that.guests = that.guests.filter(function( obj ) {
            return obj._id !== guest._id;
          });
        },
        err => {
          alert("Could not delete guest");
        });
    }, () => {
      // Cancel
    });
  }

  openGuestInfoModal(guest) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'guestInfoComponent',
      resolve: {
        config: function() {
          return {
            guest
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function () {},
      function () { /* cancel */ }
    );

  }
}

export default angular.module('conduuApp.piperGuestList', [uiRouter])
  .config(routes)
  .component('piperGuestList', {
    template: require('./guest.html'),
    controller: PiperGuestListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/piper/guest/list/guest.component.js